<template><div><h1 id="auswertung-nachlass" tabindex="-1"><a class="header-anchor" href="#auswertung-nachlass"><span>Auswertung Nachlass</span></a></h1>
<p>Nachlass — Auswertung Nachlass</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Auswertung eines Nachlasses.</p>
<p>Pfad: <code v-pre>Nachlass → Auswertungen → Nachlassauswertung</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Periode von</dt>
<dd>Zeitraum der Auswertung nach Jahren (von Jahr)</dd>
<dt>bis</dt>
<dd>Zeitraum der Auswertung nach Jahren (bis Jahr)</dd>
<dt>Status</dt>
<dd>Einschränkung nach Status (in bearbeitung und/oder abgeschlossen)</dd>
<dt>Verfügungstyp</dt>
<dd>Einschränkung nach Verfügungstyp</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten (aktuell WWF-spezifisch):</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Verfügungstyp</td>
<td>Verfügungstyp</td>
</tr>
<tr>
<td>Name Vorname</td>
<td>Name Vorname</td>
</tr>
<tr>
<td>FT-Nr.</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Kanton</td>
<td>Kanton</td>
</tr>
<tr>
<td>Zuständige)r)</td>
<td>Zuständige(r)</td>
</tr>
<tr>
<td>Willensvollstrecker</td>
<td>Willensvollstrecker</td>
</tr>
<tr>
<td>ETes</td>
<td>ETes</td>
</tr>
<tr>
<td>Letzte Verfügungsdatum</td>
<td>Letzte Verfügungsdatum</td>
</tr>
<tr>
<td>Erhalt eröffnung</td>
<td>Erhalt eröffnung</td>
</tr>
<tr>
<td>WWF Anteil</td>
<td>WWF Anteil</td>
</tr>
<tr>
<td>WWF Anteil CHF</td>
<td>WWF Anteil CHF</td>
</tr>
<tr>
<td>Sicherheitsreserve %</td>
<td>Sicherheitsreserve %</td>
</tr>
<tr>
<td>exkl. Sicherheitsreserve</td>
<td>exkl. Sicherheitsreserve</td>
</tr>
<tr>
<td>Fälligkeit</td>
<td>Fälligkeit</td>
</tr>
<tr>
<td>Betrag zu buchen</td>
<td>Betrag zu buchen</td>
</tr>
<tr>
<td>Aktionsdatum</td>
<td>Aktionsdatum</td>
</tr>
<tr>
<td>Erste Zusage</td>
<td>Erste Zusage</td>
</tr>
<tr>
<td>Differenz</td>
<td>Differenz</td>
</tr>
<tr>
<td>Buchungssummer</td>
<td>Buchungssummer</td>
</tr>
<tr>
<td>gebucht</td>
<td>gebucht</td>
</tr>
<tr>
<td>einbezahlter Betrag</td>
<td>einbezahlter Betrag</td>
</tr>
<tr>
<td>einbezahlt Periode</td>
<td>einbezahlt Periode</td>
</tr>
<tr>
<td>Bemerkungen</td>
<td>Bemerkungen</td>
</tr>
<tr>
<td>WWF Alleinerbe</td>
<td>WWF Alleinerbe</td>
</tr>
<tr>
<td>Weitere NGO's?</td>
<td>Weitere NGO's?</td>
</tr>
<tr>
<td>NGO's</td>
<td>NGO's</td>
</tr>
<tr>
<td>Zweckbindung?</td>
<td>Zweckbindung?</td>
</tr>
<tr>
<td>Zweckbindung Bemerkungen</td>
<td>Zweckbindung Bemerkungen</td>
</tr>
<tr>
<td>Projektname</td>
<td>Projektname</td>
</tr>
<tr>
<td>Liegenschaft</td>
<td>Liegenschaft</td>
</tr>
<tr>
<td>Pers. Situation</td>
<td>Pers. Situation</td>
</tr>
<tr>
<td>Status S</td>
<td>Status S</td>
</tr>
<tr>
<td>Status Z</td>
<td>Status Z</td>
</tr>
<tr>
<td>Gesamtumsatz</td>
<td>Gesamtumsatz</td>
</tr>
<tr>
<td>Geschlecht</td>
<td>Geschlecht</td>
</tr>
<tr>
<td>Geburtsdatum</td>
<td>Geburtsdatum</td>
</tr>
<tr>
<td>Alter bei Tod</td>
<td>Alter bei Tod</td>
</tr>
<tr>
<td>Tage Testamentdatum Tod</td>
<td>Tage Testamentdatum Tod</td>
</tr>
<tr>
<td>Status Nachlass</td>
<td>Status Nachlass</td>
</tr>
<tr>
<td>Abschlussdatum</td>
<td>Abschlussdatum</td>
</tr>
<tr>
<td>Archivnummer</td>
<td>Archivnummer</td>
</tr>
</tbody>
</table>
</div></template>


